import React from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  CreateTallySheetHelp,
  CreateNotesHelp,
  CreateInboundSetupHelp,
  EditTallySheetLogHelp,
  EditInboundSetupHelp,
  EditDispatchLogHelp,
  EditHistoryLogHelp,
  EditNoteLogHelp,
  DocData,
} from "./InboundHelpComponents";

const useStyles = makeStyles(() => ({
  icon: {
    verticalAlign: "middle",
    display: "inline-flex",
  },
}));

export const InboundCreateHelp = (props) => {
  const classes = useStyles();
  const tabNames = props?.location.pathname.split("/");
  const tab = tabNames?.length > 3 ? tabNames[3] : "";

  switch (tab) {
    case "":
      return <CreateInboundSetupHelp classes={classes} />;
    case "tallySheet":
      return <CreateTallySheetHelp classes={classes} />;
    case "notes":
      return <CreateNotesHelp classes={classes} />;
    default:
      return null;
  }
};

export const InboundEditHelp = ({ receiptData, ...props }) => {
  const classes = useStyles();
  const tabNames = props?.location.pathname.split("/");
  const tab = tabNames?.length > 3 ? tabNames[3] : "";

  switch (tab) {
    case "":
      return (
        <EditInboundSetupHelp receiptData={receiptData} classes={classes} />
      );
    case "historyLog":
      return <EditHistoryLogHelp classes={classes} />;
    case "tallySheet":
      return <EditTallySheetLogHelp classes={classes} />;
    case "dispatch":
      return <EditDispatchLogHelp classes={classes} />;
    case "notes":
      return <EditNoteLogHelp classes={classes} />;
    default:
      return null;
  }
};

// TODO - is this needed???
// export const InboundDynamicEditHelp = ({ bolData }) => {
//   return (
//     <li>
//       <Typography>
//         <strong>Receipt Data: </strong>
//       </Typography>
//       <DocData obj={bolData} />
//     </li>
//   );
// };
